// extracted by mini-css-extract-plugin
export default {"menu":"Nav_menu__6EOEA","logo":"Nav_logo__pttRV","menuHeader":"Nav_menuHeader__Xo1lA","menuBody":"Nav_menuBody__vsvHv","menuBodyLink":"Nav_menuBodyLink__frT3F"};